<template>
  <div class="container">
    <div class="main">
      <div class="title" > D1GP北京内海彰乃以2档勇夺追走亚军！ </div>
      <div style="color :gray;font-size :14px;text-align:center;margin-bottom:20px">2018-5-21</div>
      <div style="line-height:30px">
        <div style="text-indent:30px"> 上周末代表日本漂移高水平的比赛----2018 D1 GRAND PRIX(以下简称D1GP)漂移大奖赛中国杯北京站在北京亚袖汽车运动基地圆满落幕，这也是2018年D1GP中国杯开幕战。</div>  
      </div>

      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2018_05_21/img1.png')"
          fit="fit">
        </el-image>
      </div>

      <div style="line-height:30px">
        <div style="text-indent:30px"> 今年DIXCEL with TOYO TIRES继续派出“单走小王子”内海彰乃参赛，战车为上图这辆NISSAN Silvia S15 。</div>  
      </div>

      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2018_05_21/img2.png')"
          fit="fit">
        </el-image>
      </div>

      <div style="line-height:30px">
        <div style="text-indent:30px"> 此次DIXCEL为其定制了最新的制动方案：DIXCEL锻造四活塞卡钳、Z  Type刹车片、两片式浮动碟套件，加持中...</div>  
      </div>
      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2018_05_21/img3.png')"
          fit="fit">
        </el-image>
      </div>
      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2018_05_21/img4.png')"
          fit="fit">
        </el-image>
      </div>
      <div style="line-height:30px">
        <div style="text-indent:30px"> 上车后制动效果以及外观自然都是极好的~。 </div>  
      </div>
      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2018_05_21/img5.png')"
          fit="fit">
        </el-image>
      </div>
      <div style="line-height:30px">
        <div style="text-indent:30px"> 后刹则是沿用原厂卡钳，并升级DIXCEL   RD  Type漂移专用片、SD  Type划线盘。 </div>  
      </div>
      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2018_05_21/img6.png')"
          fit="fit">
        </el-image>
      </div>
      <div style="line-height:30px">
        <div style="text-indent:30px"> 刹车油自然也是DIXCEL  328Racing </div>  
      </div>
      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2018_05_21/img7.png')"
          fit="fit">
        </el-image>
      </div>
      <div style="line-height:30px">
        <div style="text-indent:30px"> 技师“添油加醋”中... </div>  
      </div>
      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2018_05_21/img8.png')"
          fit="fit">
        </el-image>
      </div>
      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2018_05_21/img9.png')"
          fit="fit">
        </el-image>
      </div>
      <div style="line-height:30px">
        <div style="text-indent:30px"> 此次D1GP内海彰乃与川畑真人于追走决赛中相遇，决赛前内海的战车因变速器故障只能使用1、2档完成比赛，这也就意味着内海需要使用比平时更高的发动机转速来完成此次决赛，我们知道顶级车手都拥有赛道上无可匹敌的统治力，除了他们的良好车感和过人的操控技术外，稳定可靠、高性能的刹车系统也可以让车手拥有更稳定的发挥来应对这类赛道上的突发情况，最终内海以总比分0.5分之差勇夺追走亚军。同时也让我们期待下一站：D1GP上海站，DIXCEL with TOYO TIRES内海彰乃能取得更优异的成绩。 </div>  
      </div>
      <div style="line-height:30px">
        <div style="text-indent:30px"> 我们六月  上海见~ </div>  
      </div>
      

    </div>
  </div>
</template>


<script>
    export default {
      data() {
        return{

        }
      }
    }
  </script>

<style lang="stylus" scoped>


.container
  background-color : #000
  .box_one 
    width: 100%;

  .box_bottom
    width: 100%;
    background-color #000


.main {
  margin-bottom: 5px;
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding: 62px 50px 52px;
}
  .title {
    color :#ab191d;
    text-align:center;
    margin-bottom 10px
  }


</style>